import { useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { Tooltip } from 'primereact/tooltip';
import { Generico } from '../../Generico';

export const FiltroAutocomplete = ({ id, value, onChange, fetchData, opcionesLocales = [], placeholder = "Buscar...", fieldLabel = "label", tooltipPosition = "right", icon = "pi pi-search", ...props }) => {
    const { toHtmlId } = Generico();
    const [sugerencias, setSugerencias] = useState([]);
    const [cargando, setCargando] = useState(false);

    const buscarSugerencias = (event) => {
        const query = event.query?.trim() ?? '';
        if (query.length < 2) {
            if (!query) {
                setSugerencias([...opcionesLocales]); // Nueva referencia en memoria, obliga a abrir las opciones
            } else {
                const filtradas = opcionesLocales.filter((opcion) => { // Si tiene 1 letra, filtra las opciones precargadas localmente
                    const texto = opcion?.[fieldLabel] ?? opcion;
                    return texto.toLowerCase().includes(query.toLowerCase());
                });
                setSugerencias(filtradas);
            }
            return;
        }
        setCargando(true);
        fetchData(query).then((resultados) => {
            setSugerencias(resultados)
        }).catch((error) => {
            setSugerencias([]);
            throw error;
        }).finally(() => {
            setCargando(false);
        });
    };

    // Template para las opciones del DROPDOWN
    const itemTemplate = (option) => {
        const label = option?.[fieldLabel] ?? option;
        const tooltipId = toHtmlId('tooltip-ac', option?.value ?? label);

        const handleMouseEnter = (e) => {
            const el = e.currentTarget;
            if (el.scrollWidth <= el.offsetWidth) {
                el.removeAttribute('data-pr-tooltip');
            } else {
                el.setAttribute('data-pr-tooltip', label);
            }
        };

        return (
            <div style={{ width: '100%', overflow: 'hidden' }}>
                <span id={tooltipId} data-pr-tooltip={label} data-pr-position={tooltipPosition} onMouseEnter={handleMouseEnter}
                    style={{ display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '250px', cursor: 'default', }}
                >
                    {label}
                </span>
                <Tooltip target={`#${tooltipId}`}
                    pt={{
                        text: {
                            style: { maxWidth: '300px', whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'justify' }
                        }
                    }} />
            </div>
        );
    };

    // Template para los CHIPS ya seleccionados
    const selectedItemTemplate = (option) => {
        const label = option?.[fieldLabel] ?? option;
        const tooltipId = toHtmlId('tooltip-chip', option?.value ?? label);

        return (
            <span id={tooltipId} data-pr-tooltip={label} data-pr-position={tooltipPosition}
                style={{ display: 'inline-block', maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'middle', cursor: 'default', }}
            >
                {label}
                <Tooltip target={`#${tooltipId}`}
                    pt={{
                        text: {
                            style: { maxWidth: '300px', whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'justify' }
                        }
                    }}
                />
            </span>
        );
    };

    return (
        <div className="p-inputgroup w-full">
            <span className="p-inputgroup-addon bg-white px-3">
                <i className={`${cargando ? 'pi pi-spin pi-spinner' : icon} text-primary`}></i>
            </span>
            <AutoComplete emptyMessage="No se encontraron resultados" delay={500} {...props} id={id} value={value || []} suggestions={sugerencias} completeMethod={buscarSugerencias}
                field={fieldLabel} multiple onChange={(e) => onChange(e.value)} placeholder={placeholder} className="w-full"
                itemTemplate={itemTemplate} selectedItemTemplate={selectedItemTemplate} dropdownIcon="pi pi-chevron-down" />
        </div>
    );
};